<template>
  <PageLayout>
    <template #header>
      <div></div>
    </template>
    <ProfilePageContent />
  </PageLayout>
</template>
